// ラベル
export const LABELS = {
  EXAMINATION_COMMENT_REGISTRATION: "審査コメント登録",
  EXAMINATION_COMMENT: "審査コメント",
  EXAMINATION_COMMENT_DOCOMO: "審査コメント（ドコモ）",
  EXAMINATION_JUDGEMENT_CODE_DOCOMO: "審査判定コード（ドコモ）",
  EXAMINATION_COMMENT_VM_TF: "審査コメント（V/M（TF））",
  EXAMINATION_COMMENT_VM_SMCC: "審査コメント（V/M（SMCC））",
  EXAMINATION_COMMENT_VM_SAISON: "審査コメント（V/M（セゾン））",
  EXAMINATION_COMMENT_JCB: "審査コメント（JCB）",
  EXAMINATION_COMMENT_AMEX: "審査コメント（AMEX）",
  SEND_BACK_COMMENT: "差戻コメント",
  EXAMINATION_RESULT_APPROVAL: "審査結果承認",
  EXAMINATION_RESULT: "審査結果",
  APPROVAL_DATE: "承認日",
  APPROVER: "承認者",
  APPROVAL_OR_SEND_BACK_COMMENT: "承認または差戻コメント",
  APPROVAL_REASON: "承認コメント",
  NG: "NG",
  OK: "OK",
  AUTOMATIC_EXAMINATION: "自動審査済",
};
// 画面表示切替用
export const NEW_OR_PULLBACK = 0;
export const SEND_BACK = 1;
export const REQUEST_AFTER_FOR_REQUESTER = 2;
export const REQUEST_AFTER_FOR_APPROVER_ADMIN = 3;
export const REQUEST_AFTER_FOR_APPROVER = 4;
export const APPROVAL_AFTER = 5;
// コメント最大文字数
export const COMMENT_MAX_LENGTH = 500;
// 審査ステータス
export const EXAMINATION_COMPREHENSIVE_WAITING_MANUAL = 102;
// ステータスIF
interface IStatusObj {
  value: string;
  label: string;
}
// 審査結果
interface IExaminationResult {
  ng: IStatusObj;
  ok: IStatusObj;
  automaticExamination: IStatusObj;
}
export const EXAMINATION_RESULT: IExaminationResult = {
  ng: {
    value: "201",
    label: LABELS.NG,
  },
  ok: {
    value: "301",
    label: LABELS.OK,
  },
  // 手動審査不要(自動承認OK)の場合
  automaticExamination: {
    value: "399",
    label: LABELS.OK,
  },
};
// 審査結果セレクトボックス
export const EXAMINATION_RESULT_SELECT: IStatusObj[] = [
  { value: EXAMINATION_RESULT.ng.value, label: EXAMINATION_RESULT.ng.label },
  { value: EXAMINATION_RESULT.ok.value, label: EXAMINATION_RESULT.ok.label },
];
